export default __webpack_public_path__ + "static/media/achievement_speech_drama.8f0cdbfa.mp3";